import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { AlgebraKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<AlgebraKey, string>,
  ro: ro as Record<AlgebraKey, string>,
} as const satisfies Partial<Record<LangCode, Record<AlgebraKey, string>>> & {
  en: Record<AlgebraKey, string>;
};
export type { AlgebraKey } from './keys';
